import React, { useState } from 'react';
import { X, Send, AlertCircle } from 'lucide-react';
import api from '../services/api';
import { formatPrice } from '../utils/formatters';

const CounterOfferModal = ({ offer, onClose, onCounterSent }) => {
  const [amount, setAmount] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const vehicle = offer?.vehicle || {};
  const currentAmount = offer?.amount;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!amount || amount <= 0) {
      setError('Veuillez entrer un montant valide');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await api.post(`/marketplace/offers/${offer.id}/counter`, {
        amount: parseInt(amount),
        message: message || null,
      });
      if (onCounterSent) onCounterSent();
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors de l\'envoi de la contre-offre');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-end sm:items-center justify-center z-50 p-0 sm:p-4">
      <div className="bg-dark-card w-full sm:w-[440px] sm:rounded-2xl rounded-t-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-dark-border">
          <h2 className="text-lg font-bold text-primary">Contre-offre</h2>
          <button onClick={onClose} className="p-1 hover:bg-dark-hover rounded-full transition-colors">
            <X className="h-5 w-5 text-muted" />
          </button>
        </div>

        {/* Context */}
        <div className="px-5 py-4 bg-dark-hover">
          <div className="flex items-center gap-3">
            {vehicle.images?.[0] && (
              <img src={vehicle.images[0]} alt="" className="w-14 h-10 rounded-lg object-cover" />
            )}
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-primary truncate">{vehicle.make} {vehicle.model}</p>
              <p className="text-sm text-secondary">Offre actuelle : <span className="font-bold text-primary">{formatPrice(currentAmount)}</span></p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div>
            <label className="block text-sm font-medium text-label mb-2">Votre contre-offre</label>
            <div className="relative">
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Nouveau montant"
                className="w-full pl-4 pr-12 py-3 text-xl font-bold bg-dark-input border-2 border-dark-border text-primary rounded-xl focus:border-carmin focus:ring-0 transition-colors placeholder-muted"
                min="1"
                autoFocus
              />
              <span className="absolute right-4 top-1/2 -translate-y-1/2 text-muted font-medium">€</span>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-label mb-2">
              Message <span className="text-muted font-normal">(optionnel)</span>
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={2}
              maxLength={500}
              className="w-full px-4 py-3 bg-dark-input border-2 border-dark-border text-primary rounded-xl focus:border-carmin focus:ring-0 resize-none text-sm transition-colors placeholder-muted"
            />
          </div>

          {error && (
            <div className="flex items-center gap-2 text-red-400 text-sm bg-red-900/20 p-3 rounded-lg border border-red-900/30">
              <AlertCircle className="h-4 w-4 flex-shrink-0" />
              {error}
            </div>
          )}

          <p className="text-xs text-muted">
            Round {(offer?.round_number || 0) + 1}/3 — {3 - (offer?.round_number || 0)} négociation(s) restante(s).
          </p>

          <button
            type="submit"
            disabled={loading || !amount}
            className="w-full flex items-center justify-center gap-2 py-3.5 bg-carmin text-white rounded-xl font-semibold hover:bg-carmin-light disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <Send className="h-4 w-4" />
                Envoyer la contre-offre
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CounterOfferModal;
